# Place all the behaviors and hooks related to the matching controller here.
# All this logic will automatically be available in application.js.
# You can use CoffeeScript in this file: http://jashkenas.github.com/coffee-script/
$(document).on 'turbolinks:load', ->
  $("#service_service_date").datetimepicker({timeFormat: 'HH:mm', language: 'cs-CZ', dateFormat: "yy-mm-dd" })
  
  service_recalc = ->
    pcs = $("input#service_pcs")
    price = $("input#service_price")
    total = pcs.val() * price.val()
    $("input#service_total_price").val total.toFixed(2)

  $("input.calc").keyup ->
    service_recalc()
  
  $("#service_service_type_id").change ->
    $.get "/service_types/" + $(this).val() + ".json", (data, status, xhr) ->
      data = eval(data)
      $("input#service_price").val data.price

  $("#min15").click ->
      $("input#service_pcs").val 0.25
      service_recalc()
      false
  $("#min20").click ->
      $("input#service_pcs").val 0.33
      service_recalc()
      false
  $("#min30").click ->
      $("input#service_pcs").val 0.5
      service_recalc()
      false
  $("#min40").click ->
      $("input#service_pcs").val 0.67
      service_recalc()
      false
  $("#min45").click ->
      $("input#service_pcs").val 0.75
      service_recalc()
      false

  